import { FormComponentFactory } from "../FormComponentFactory";
import { Component, ComponentConfig } from "../Component";
import {
  useComponentConfigAtom,
  useComponentCustomOrEditConfigAtom,
  useOutputWire,
} from "../state/ComponentAtoms";
import { ComponentEditorOption } from "../ComponentEditorOption";
import { Button } from "@mui/material";
import { useCallback } from "react";

interface ButtonComponent extends ComponentConfig {
  title: string;
}
const ComponentName = "Button";
export function registerButtonComponent() {
  FormComponentFactory.addComponent(ComponentName, {
    config: () => {
      return {
        title: "Button",
        connections: {
          inputs: [],
          outputs: [],
          inputConnectors: {},
          outputConnectors: {},
        },
      };
    },
    component: (config: Component) => {
      return <ButtonDisplay key={"Display-" + config.id} config={config} />;
    },
    editor: (config: Component) => {
      return (
        <ButtonEditor key={"Editor-" + config.id} componentId={config.id} />
      );
    },
    fixedOutputs: () => {
      return ["onClick"];
    },
  });
  // Add old names for legacy config
  FormComponentFactory.addAlias("Button", ComponentName);
}

function ButtonDisplay({ config }: { config: Component }) {
  const [vanillaComponentConfig] = useComponentCustomOrEditConfigAtom(
    config.id
  );
  const componentConfig = vanillaComponentConfig as ButtonComponent;
  /// Set up handlers for output wiring
  const onClickWireKey =
    componentConfig.connections?.outputConnectors["onClick"] ?? "dummy";
  let setWireValue = useOutputWire(onClickWireKey);
  const onClickHandler = useCallback(() => {
    setWireValue(true);
  }, [onClickWireKey]);
  return <Button onClick={onClickHandler}>{componentConfig.title}</Button>;
}

function ButtonEditor({ componentId }: { componentId: string }) {
  const [config, setConfig] = useComponentConfigAtom(componentId);
  const componentConfig = config.editConfig as ButtonComponent;
  const setTitle = (newTitle?: string) => {
    setConfig((config: Component) => {
      return {
        ...config,
        ...{
          editConfig: { ...config.editConfig, ...{ title: newTitle } },
        },
      };
    });
  };
  return (
    <ComponentEditorOption
      name="Button Text"
      value={componentConfig.title}
      onChange={setTitle}
    />
  );
}
